import { style } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ThemeColorIndexConstants } from 'devexpress-richedit/lib/core/model/color/enums';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { DurationWorkSystemDetail } from 'src/app/Interfaces/hr/employee-duration';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { EmployeeDurationService } from 'src/app/shared/services/hr/employee-duration.service';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';

@Component({
  selector: 'app-employee-duration',
  templateUrl: './employee-duration.component.html',
  styleUrls: ['./employee-duration.component.scss'],
  providers: [DatePipe]
})

export class EmployeeDurationComponent extends SuperComponent implements OnInit {
  employeeduration_id: number;
  employeeDuration: any = []
  activeday: number;
  tablelist: DurationWorkSystemDetail[] = []
  from: any;
  to: any;

  vacationvalue: any = [];
  breakvalue: any;
  workvalue: any

  holiday_vacation: boolean = false;

  employeedropdown = []
  WeekDaysList: any = []
  durationworkdropdown: any = []
  breakdropdown: any = []

  breakDataSource: any = [];
  weekDataSource: any = [];
  workDataSource: any = [];
  
  Holidayarray = [{
    dataField: 'nameAr',
    caption: this.translate.instant('tableinfo.NameAr'),
  }, {
    dataField: 'attendanceFromHour',
    caption: this.translate.instant('tableinfo.attendanceFromHour'),
  },
  {
    dataField: 'leaveToHour',
    caption: this.translate.instant('tableinfo.leaveToHour'),
  }];

  Vacationarray = [{
    dataField: 'nameAr',
    caption: this.translate.instant('tableinfo.NameAr'),
  }]

  buttonOptions = {
    text: this.translate.instant('employeeduration.show'),
    type: 'default',
    stylingMode: 'outlined',
    useSubmitBehavior: true,
  };
  
  buttonemployeedurationOptions = {
    useSubmitBehavior: true,
  };
  
  employeeColumns = [
    {
      dataField: 'employeeNameAr',
      caption: this.translate.instant('hr.employeeId'),
      allowColumnResizing: true
    }, 
    {
      dataField: 'branchName',
      caption: this.translate.instant('basic-info.branch.branchName'),
      allowColumnResizing: true
    },
    {
      dataField: 'employeeWorkStatus',
      caption: this.translate.instant('hr.EmployeeStatus'),
      allowColumnResizing: true
    },
    {
      dataField: 'departmentName',
      caption: this.translate.instant('salary.department'),
      width: 100,
    },
    {
      dataField: 'managementName',
      caption: this.translate.instant('salary.management'),
      width: 100,
    },
    {
      dataField: 'jobName',
      caption: this.translate.instant('salary.jobTitleId'),
      allowColumnResizing: true
    },
    {
      dataField: 'employeeWorkSystem',
      caption: this.translate.instant('salary.workSystem'),
      allowColumnResizing: true
    }
  ];
  
  filteredEmployeeColumns = this.employeeColumns.filter(col => 
    ['employeeNameAr', 'branchName', 'departmentName', 'employeeWorkStatus', 'employeeWorkSystem', 'managementName'].includes(col.dataField)
  );
  
  cdr: any;
  selectedEmployee: number[];
  employeeinformation: never[];
  jobTitleDropDown: any;
  branchesdropdown: any;
  employeedropDowm: any;
  bankDropDown: any;
  departmentDropDown: any;
  managementDropDown: any;
  WorkSystemDropDown: any;
  selectedBranch: number[];
  selectedJob: number[];
  selectedManagement: number[];
  selectedWorkSystem: number[];
  selectedDepartment: number[];
  selectedWorkDurations: number[];
  selectedBreaks: number[];
//   overrideFrom: string | number | Date;
// overrideTo: string | number | Date;
// overrideDurations: number[] = [];
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(
    gt: genericCustomStoreService,
    public http: HttpClient,
    public datePipe: DatePipe,
    public router: Router,
    public _EmployeeDurationService: EmployeeDurationService,
    translate: TranslateService,
    public NotifyService: NotifyService,
    Objects: ObjectsService
  ) { 
    super(Objects, translate, gt)
    this.WeekDaysList = Objects.WeekDaysList
    gt.getdropdowndata('Employee').subscribe((res: any) => this.employeedropdown = res)
    gt.getdropdowndata('Break').subscribe((res) => this.breakdropdown = res) 
    gt.getdropdowndata('DurationWorkSystem').subscribe((res) => this.durationworkdropdown = res) 
    this.breakDataSource = this.makeAsyncBreakList(); 
    this.workDataSource = this.makeAsyncworkList(); 
    this.weekDataSource = this.makeAsyncWeekList(); 
    this.onBreakChanged = this.onBreakChanged.bind(this); 
    this.onholidayChanged = this.onholidayChanged.bind(this); 
  }

  ngOnInit(): void {
    this.vacationvalue = [];
    this.gt.dropdown('Employee/GetDropDown/EmployeeInformation').subscribe(
      (res: []) => this.employeeinformation = res.filter((x: any) => x.bankcode != ''))
    this.getBranchesDropDown();
    this.getAllEmployeeDropDown();
    this.getAllJobTitledDropDown();
    this.getAllbankDropDown();
    this.getAlldepartmentDropDown();
    this.getAllmanagementDropDown();
    this.getAllWorkSystemDropDown();
  }
  
  initializeColumns() {
    this.employeeColumns = [
      {
        dataField: 'employeeNameAr',
        caption: this.translate.instant('hr.employeeId'),
        allowColumnResizing: true
      },
      {
        dataField: 'branchName',
        caption: this.translate.instant('basic-info.branch.branchName'),
        allowColumnResizing: true
      },
      {
        dataField: 'employeeWorkStatus',
        caption: this.translate.instant('hr.EmployeeStatus'),
        allowColumnResizing: true
      },
      {
        dataField: 'departmentName',
        caption: this.translate.instant('salary.department'),
        allowColumnResizing: true
      },
      {
        dataField: 'managementName',
        caption: this.translate.instant('salary.management'),
        allowColumnResizing: true
      },
      {
        dataField: 'employeeWorkSystem',
        caption: this.translate.instant('salary.workSystem'),
        allowColumnResizing: true
      }
    ];
  
    setTimeout(() => {
      this.filteredEmployeeColumns = this.employeeColumns.filter(col =>
        ['employeeNameAr', 'branchName', 'departmentName', 'employeeWorkStatus', 'employeeWorkSystem', 'managementName'].includes(col.dataField)
      );
      this.cdr.detectChanges();
    }, 0);
  } 
  
  onEmployeeSelectionChanged(selectedRowKeys: number[]) {
    this.selectedEmployee = selectedRowKeys;
    console.log('Selected Employee IDs', this.selectedEmployee);
  }
actualFromDate: any;
actualToDate: any;
// applyPartialOverride() {
//   if (!this.overrideFrom || !this.overrideTo || this.overrideDurations.length === 0) {
//     this.NotifyService.notifyfun("يرجى اختيار التاريخ والفترات أولاً");
//     return;
//   }

  
//   const fromDateStr = this.datePipe.transform(this.overrideFrom, 'yyyy-MM-dd');
//   const toDateStr = this.datePipe.transform(this.overrideTo, 'yyyy-MM-dd');


//   this.tablelist = this.tablelist.map(row => {
//     const rowDateStr = this.datePipe.transform(row.dateTimeRegister, 'yyyy-MM-dd');

   
//     if (rowDateStr && fromDateStr && toDateStr && rowDateStr >= fromDateStr && rowDateStr <= toDateStr) {
//       return {
//         ...row,
       
//         durationWorkSystemEmployeesArray: [...this.overrideDurations]
//       };
//     }
//     return row; // إبقاء الصف كما هو إذا كان خارج النطاق
//   });

//   this.NotifyService.notifyfun("تم تحديث الفترة المختارة في الجدول بنجاح");
// }

//الفكره فالactuql date  انه بياخد من الinput  تاريخ اول فتره بيضف ليها فترات عمل للموظف مش التواريخ بتاعه التعديل بس لفتره معينه
applyOverrideFromMainInputs() {
  const from = this.employeeDuration.from;
  const to = this.employeeDuration.to;
  
  const newDurations = this.selectedWorkDurations || [];
  const newBreaks = this.selectedBreaks || [];

  if (!from || !to) {
    this.NotifyService.notifyerrMessage("يرجى تحديد تاريخ البداية والنهاية أولاً");
    return;
  }

  const fromStr = this.datePipe.transform(from, 'yyyy-MM-dd');
  const toStr = this.datePipe.transform(to, 'yyyy-MM-dd');

  this.tablelist = this.tablelist.map(row => {
    const rowDateStr = this.datePipe.transform(row.dateTimeRegister, 'yyyy-MM-dd');

    if (rowDateStr && fromStr && toStr && rowDateStr >= fromStr && rowDateStr <= toStr) {
      return {
        ...row,
        durationWorkSystemEmployeesArray: [...newDurations],
        durationWorkSystemEmployeeBreaksArray: [...newBreaks]
      };
    }
    return row;
  });

  if (this.grid && this.grid.instance) {
    this.grid.instance.refresh();
  }

  this.NotifyService.notifyfun("تم تحديث الفترات في الجدول بنجاح");
}
  onBranchSelectionChanged(selectedRowKeys: number[]) {
    this.selectedBranch = selectedRowKeys;
    console.log('Selected Branch IDs', this.selectedBranch);
  }
  
  onJobTitleSelectionChanged(selectedRowKeys: number[]) {
    this.selectedJob = selectedRowKeys;
    console.log('Selected Job IDs', this.selectedJob);
  }
  
  onManagementSelectionChanged(selectedRowKeys: number[]) {
    this.selectedManagement = selectedRowKeys;
    console.log('Selected Management IDs', this.selectedManagement);
  }
  
  onWorkSystemSelectionChanged(selectedRowKeys: number[]) {
    this.selectedWorkSystem = selectedRowKeys;
    console.log('Selected WorkSystem IDs', this.selectedWorkSystem);
  }
  
  onDepartmentSelectionChanged(selectedRowKeys: number[]) {
    this.selectedDepartment = selectedRowKeys;
    console.log('Selected Department IDs', this.selectedDepartment);
  }

  onWorkDurationChanged(selectedRowKeys: number[]) {
    setTimeout(() => {
      this.selectedWorkDurations = selectedRowKeys || [];
      console.log('Selected WorkDuration IDs', this.selectedWorkDurations);
    });
  }

  onBreakDurationChanged(selectedRowKeys: number[]) {
    setTimeout(() => {
      this.selectedBreaks = selectedRowKeys || [];
      console.log('Selected Break IDs', this.selectedBreaks);
    });
  }

  onFormSubmit(e: Event) {
    e.preventDefault();

    const from = this.datePipe.transform(this.employeeDuration.from, 'yyyy-MM-dd');
    const to = this.datePipe.transform(this.employeeDuration.to, 'yyyy-MM-dd');

    if (!from || !to) return;

    const employeeIds = this.selectedEmployee || [];
    const branchIds = this.selectedBranch || [];
    const departmentIds = this.selectedDepartment || [];
    const managementIds = this.selectedManagement || [];
    const jobTitleIds = this.selectedJob || [];
    const workSystemIds = this.selectedWorkSystem || [];

    const safeWorkDurations = Array.isArray(this.selectedWorkDurations)
       ? this.selectedWorkDurations
       : [];
    const safeBreaks = Array.isArray(this.selectedBreaks)
       ? this.selectedBreaks
       : [];

    this._EmployeeDurationService
      .byKey(
        employeeIds,
        from,
        to,
        jobTitleIds,
        departmentIds,
        workSystemIds,
        managementIds,
        branchIds
      )
      .subscribe({
        next: (res: { data: any[] }) => {
          const existingData = Array.isArray(res.data) ? res.data.flat() : [];
          const allEmployeeIds = [...new Set(existingData.map(x => x.employeeId))];

          const employeeNameMap: Record<number, string> = {};
          existingData.forEach(x => {
            if (x.employeeId && x.employeeName) {
              employeeNameMap[x.employeeId] = x.employeeName;
            }
          });

          this.employeedropdown.forEach((emp: any) => {
            if (emp.id && emp.nameAr && !employeeNameMap[emp.id]) {
              employeeNameMap[emp.id] = emp.nameAr;
            }
          });

          const allDates = this.generateDateRange(from!, to!);
          const allCombinations: DurationWorkSystemDetail[] = [];

          allEmployeeIds.forEach((empId: number) => {
            const empName = employeeNameMap[empId] || '—';

            allDates.forEach((date) => {
              const dayEnum = this.getDayEnumValue(date);

              const existing = existingData.find(
                (x) =>
                  x.employeeId === empId &&
                  this.datePipe.transform(x.dateTimeRegister, 'yyyy-MM-dd') === date
              );

            if (existing) {
  allCombinations.push({
    ...existing,
    employeeName: empName,
    vacation: this.vacationvalue.includes(dayEnum),

    // ✅ لو المستخدم اختار فترات جديدة → استخدمها
    // لو مختارش → استخدم اللي في الـ DB
    durationWorkSystemEmployeesArray:
      safeWorkDurations.length > 0
        ? [...safeWorkDurations]
        : (Array.isArray(existing.durationWorkSystemEmployeesArray)
            ? existing.durationWorkSystemEmployeesArray
            : []),

    durationWorkSystemEmployeeBreaksArray:
      safeBreaks.length > 0
        ? [...safeBreaks]
        : (Array.isArray(existing.durationWorkSystemEmployeeBreaksArray)
            ? existing.durationWorkSystemEmployeeBreaksArray
            : []),
  });
} else {
                allCombinations.push({
                  id: 0,
                  employeeId: empId,
                  employeeName: empName,
                  day: dayEnum,
                  dateTimeRegister: date,
                  vacation: this.vacationvalue.includes(dayEnum),
                  durationWorkSystemEmployeesArray: [...safeWorkDurations],
                  durationWorkSystemEmployeeBreaksArray: [...safeBreaks],
                });
              }
            });
          });

          this.tablelist = [...allCombinations];
          console.log('✅ Table list updated', this.tablelist);
        },

        error: (err) => {
          console.error('❌ Error from backend', err);
          this.generateLocalTableList(from!, to!);
        },
      });
      this.actualFromDate = this.employeeDuration.from;
    this.actualToDate = this.employeeDuration.to;
  }

  private generateDateRange(from: string, to: string): string[] {
    const startDate = new Date(from);
    const endDate = new Date(to);

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    const allDates: string[] = [];
    let currentDate = new Date(startDate);

    while (currentDate.getTime() <= endDate.getTime()) {
      allDates.push(this.datePipe.transform(currentDate, 'yyyy-MM-dd')!);
      currentDate = new Date(currentDate);
      currentDate.setDate(currentDate.getDate() + 1);
      currentDate.setHours(0, 0, 0, 0);
    }

    return allDates;
  }

  private generateLocalTableList(from: string, to: string) {
    const startDate = new Date(from);
    const endDate = new Date(to);
    const days: string[] = [];

    for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
      days.push(this.datePipe.transform(d, 'yyyy-MM-dd')!);
    }

    const newList: DurationWorkSystemDetail[] = [];

    this.selectedEmployee.forEach((empId: number) => {
      days.forEach((date) => {
        const dayEnum = this.getDayEnumValue(date);
        newList.push({
          id: 0,
          employeeId: empId,
          day: dayEnum,
          dateTimeRegister: date,
          vacation: this.vacationvalue.includes(dayEnum),
          durationWorkSystemEmployeesArray: [...this.selectedWorkDurations],
          durationWorkSystemEmployeeBreaksArray: [...this.selectedBreaks],
        });
      });
    });

    this.tablelist = newList;
    console.log('✅ Generated new tablelist', this.tablelist);
  }

  getDayEnumValue(date: string): number {
    return new Date(date).getDay(); 
  }

  makeAsyncWeekList() {
    return new CustomStore({
      loadMode: 'raw',
      key: 'id',
      load: () => {
        return (this.WeekDaysList)
      },
    });
  }
  
  makeAsyncBreakList() {
    return new CustomStore({
      loadMode: 'raw',
      key: 'id',
      load: () => {
        return (this.breakdropdown)
      }
    });
  }
  
  makeAsyncworkList() {
    return new CustomStore({
      loadMode: 'raw',
      key: 'id',
      load: () => {
        return (this.durationworkdropdown)
      }
    });
  }
  
  onBreakChanged(newVal: any) {
    console.log('✅ Break value changed', newVal);
    this.breakvalue = newVal;
  }

  onholidayChanged(newVal: any) {
    console.log('✅ Vacation days selected', newVal);
    this.vacationvalue = Array.isArray(newVal) ? newVal : [];
    
    if (this.tablelist && this.tablelist.length > 0) {
      this.tablelist.forEach((ele: any) => {
        if (Array.isArray(this.vacationvalue)) {
          ele.vacation = this.vacationvalue.includes(ele.day);
        }
      });
      console.log('✅ Updated vacation status in tablelist', this.tablelist);
    }
  }
  
  // ✅ إضافة event handler جديد لحفظ التعديلات
  onRowUpdated(e: any) {
    console.log('✅ Row updated:', e.data);
    
    // البحث عن الـ row في tablelist وتحديثه
    const index = this.tablelist.findIndex(
      (row: any) => 
        row.employeeId === e.data.employeeId && 
        row.dateTimeRegister === e.data.dateTimeRegister
    );
    
    if (index !== -1) {
      // تحديث القيم في tablelist
      this.tablelist[index] = {
        ...this.tablelist[index],
        ...e.data,
        durationWorkSystemEmployeesArray: e.data.durationWorkSystemEmployeesArray || [],
        durationWorkSystemEmployeeBreaksArray: e.data.durationWorkSystemEmployeeBreaksArray || [],
        vacation: e.data.vacation
      };
      
      console.log('✅ Updated tablelist item:', this.tablelist[index]);
    }
  }
  
  // ✅ إضافة event handler لـ cell value change
  onCellValueChanged(e: any) {
    console.log('✅ Cell value changed:', {
      dataField: e.dataField,
      oldValue: e.oldValue,
      newValue: e.newValue,
      data: e.data
    });
  }
  
  onEditorPreparing(e: any) {
    if (e.parentType === 'dataRow' && e.dataField === 'durationWorkSystemEmployeesArray') {
      e.editorName = 'dxTagBox'
      e.editorOptions.dataSource = this.workDataSource;
      e.editorOptions.showSelectionControls = true;
      e.editorOptions.displayExpr = 'nameAr';
      e.editorOptions.valueExpr = 'id';
      e.editorOptions.value = e.value || []; 
      e.editorOptions.onValueChanged = (args: any) => {
        console.log('✅ Work duration changed:', args.value);
        e.setValue(args.value);
      }
    }
    else if (e.parentType === 'dataRow' && e.dataField === 'durationWorkSystemEmployeeBreaksArray') {
      e.editorName = 'dxTagBox'
      e.editorOptions.dataSource = this.breakDataSource;
      e.editorOptions.showSelectionControls = true;
      e.editorOptions.displayExpr = 'nameAr';
      e.editorOptions.valueExpr = 'id';
      e.editorOptions.value = e.value || []; 
      e.editorOptions.onValueChanged = (args: any) => {
        console.log('✅ Break duration changed:', args.value);
        e.setValue(args.value);
      }
    }
  }

  onCellPrepared(e: any) {  
    if (e.rowType == 'data' && e.column.dataField == 'dateTimeRegister') {  
      if (e.data.id != 0) {
        e.cellElement.className += ' cls'; 
      }
    }  
  } 
     
  passdatatoallrows() {
    this.tablelist.forEach((ele: any) => {
      ele.durationWorkSystemEmployeeBreaksArray = this.breakvalue
      ele.durationWorkSystemEmployeesArray = this.workvalue
      ele.vacation = this.vacationvalue.includes(ele.day);
    })  
    console.log('✅ Applied data to all rows', this.tablelist);
  }

  submit(e: any) {
    e.event.preventDefault();

    if (this.grid && this.grid.instance) {
        this.grid.instance.saveEditData();
    }

    // ✅ normalize كل التواريخ قبل الإرسال
    this.tablelist = this.tablelist.map((row: any) => ({
        ...row,
        // ✅ خلي التاريخ دايماً T00:00:00 من غير أي offset
        dateTimeRegister: this.datePipe.transform(row.dateTimeRegister, 'yyyy-MM-dd') + 'T00:00:00',
        durationWorkSystemEmployeesArray: Array.isArray(row.durationWorkSystemEmployeesArray)
            ? row.durationWorkSystemEmployeesArray
            : [],
        durationWorkSystemEmployeeBreaksArray: Array.isArray(row.durationWorkSystemEmployeeBreaksArray)
            ? row.durationWorkSystemEmployeeBreaksArray
            : []
    }));

    const allEmployeeIds = [
        ...new Set(this.tablelist.map((r: any) => r.employeeId))
    ];

    const data = {
        fromDate: this.datePipe.transform(this.actualFromDate, 'yyyy-MM-dd') + 'T00:00:00',
        toDate: this.datePipe.transform(this.actualToDate, 'yyyy-MM-dd') + 'T00:00:00',
        employeeIds: allEmployeeIds,
        branchIds: this.selectedBranch || [],
        departmentIds: this.selectedDepartment || [],
        managementIds: this.selectedManagement || [],
        jobTitleIds: this.selectedJob || [],
        workSystemIds: this.selectedWorkSystem || [],
        durationWorkSystemDetails: this.tablelist
    };

    console.log('✅ Final data to submit:', data);

    this._EmployeeDurationService.addemployee_duration(data).subscribe({
        next: () => {
            this.NotifyService.notifyfun('add');
            this.router.navigate(['hr/employeeduration']);
        },
        error: err => {
            console.error('❌ Error adding employee duration', err);
            this.NotifyService.notifyfun('error');
        }
    });
}

  backToMainPage(e: string) {
    if (e == 'back') {
      this.router.navigate(['hr/employeeduration'])
    }
  }
  
  getBranchesDropDown() {
    this.gt.getdropdowndata('Branch').subscribe((res: []) => {
      this.branchesdropdown = res
    })
  }
  
  getAllEmployeeDropDown() {
    this.gt.dropdown('Employee/GetDropDown/EmployeeInformation').subscribe((res: any) => {
      this.employeedropDowm = res;
    })
  }
  
  getAllJobTitledDropDown() {
    this.gt.getdropdowndata('JobTitle').subscribe((res: []) => {
      this.jobTitleDropDown = res
    })
  }
  
  getAllbankDropDown() {
    this.gt.getdropdowndata('Bank').subscribe((res: []) => {
      this.bankDropDown = res
       if(this.bankDropDown.length > 0&& (this.employeeDuration.id === 0||this.employeeDuration.id===undefined|| this.employeeDuration.id == null)) {
          this.employeeDuration.branchId = this.bankDropDown[0].id;    

        }
    })
  }
  
  getAlldepartmentDropDown() {
    this.gt.getdropdowndata('Department').subscribe((res: []) => {
      this.departmentDropDown = res
    })
  }
  
  getAllmanagementDropDown() {
    this.gt.getdropdowndata('Management').subscribe((res: []) => {
      this.managementDropDown = res
    })
  }
  
  getAllWorkSystemDropDown() {
    this.gt.getdropdowndata('WorkSystem').subscribe((res: []) => {
      this.WorkSystemDropDown = res
    })
  }
  onWorkSystemChanged(event: any, cellInfo: any) {
 
    cellInfo.data.durationWorkSystemEmployeesArray = event.value;
}
}